import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo(({ empty, ...params }) => (
  <GenericIcon {...params}>
    <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" />
    {empty || <path d="M9 12L11 14L15 10" />}
  </GenericIcon>
));
